import { watchMessageAndUpdateHistory, windowDispachStorage } from '../utils/app_module'

callpy_global.CChat = function()
{
    this.module_name = "Chat ";
    this.module_log_rang = 100;
    //this.history = [];

    var _this = this;

    if (callpy_from_ls == true){
        this.history = callpy_storage.m_callpy.m_chat.history;
        this.history_dialogs = callpy_storage.m_callpy.m_chat.history_dialogs;
        this.first_time = true;
        this.save_state = 0;
        this.call_status = "no_call";
    }else{
        this.history = [];
        this.history_dialogs = {};
        this.first_time = true;
        this.save_state = 0;
        this.call_status = "no_call";
    }

    this.call_type = 1;
    this.managerWriteTimer = null;
    this.setReadTimer = null;
    this.dialogRateTimer = null;

    this.init = function ()
    {
        if (m_callpy.client_data.type == 1)
        {
            //регистрируем всех менеджеров (возможно, необходимо делать в инициализации чата)
            if (m_callpy.initialize_data.init_data.managers.length>0 && (!callpy_from_ls || m_callpy.initialize_data.init_data.online == false)){
                for (var i=0; i<m_callpy.initialize_data.init_data.managers.length; i++){
                    m_callpy.register_client({action: 'register_client', key: m_callpy.initialize_data.init_data.managers[i].key, type: 2, far_id: 0, name: m_callpy.initialize_data.init_data.managers[i].name, subname: m_callpy.initialize_data.init_data.managers[i].subname, avatar: m_callpy.initialize_data.init_data.managers[i].avatar, position: m_callpy.initialize_data.init_data.managers[i].position, status: m_callpy.initialize_data.init_data.managers[i].status, globalStatus: m_callpy.initialize_data.init_data.managers[i].globalStatus, site_id: m_callpy.initialize_data.init_data.managers[i].site_id, mail: m_callpy.initialize_data.init_data.managers[i].mail, channel: m_callpy.initialize_data.init_data.managers[i].channel, webRTCsupp: m_callpy.initialize_data.init_data.managers[i].webRTCsupp, departments: m_callpy.initialize_data.init_data.managers[i].departments});
                }
            }
            //TODO: FLAT: изменить название блока Callpy
            /*m_callpy.m_gui_chat.init({
                container : $jcallpy('#callpy')
            });*/

            if (m_callpy.client_data.site_info["mobileOff"] != 1 || !m_callpy.isMobile()) $jcallpy.callpy_init();

            //UPDATED:
            //Нестандартные настройки для инициализации Callpy, если указаны глобально
            if (window.callpyInitSettings){
                if (window.callpyInitSettings.label_hidden != undefined){
                    m_callpy.client_data.site_info.label_hidden = window.callpyInitSettings.label_hidden;
                   // $jcallpy.callpy_settings('set', {label_hidden: m_callpy.client_data.site_info.label_hidden});
                }
            }

            if (m_callpy.initialize_data.init_data.manager_changed){
                m_callpy.manager_changed({action: 'manager_changed', user: m_callpy.initialize_data.init_data.manager_changed.user, manager: m_callpy.initialize_data.init_data.manager_changed.manager});
            }else{
                //====> Dessine l'acttuelle consultant disponible
                // if (!callpy_from_ls) $jcallpy?.callpy_consultant('set');
                // m_callpy.m_storage.saveData();
                //====>
            }

            //TODO: автоприветствие по числу страниц
            m_callpy.m_activity.automessage_pageCheck();

            //UPDATED: новая настройка автоматической смены отдела при переходам по страницам
            //необходимо применить фильтры отделов и сменить отдел при необходимости
            //при этом учитываются только фильтры, которые могут измениться при переходах
            //пока это только URL страницы
            if (m_callpy.client_data.site_info["s_autoDepsChange"] == 1){
                //необходимо проверить только в случае, если клиент уже был онлайн, иначе при инициализации отдел будет назначен сервером
                if (callpy_from_ls){
                    var new_department = m_callpy.m_user.getDepartment(m_callpy.client_data.site_info.filters, {referer: location.href}, m_callpy.client_data.site_info.department_id);
                    if (new_department != m_callpy.client_data.department_id){
                        $jcallpy.callpy_departments('_change_department', new_department, true);
                    }
                }
            }

        }
    };

    //установка UTM-меток на ссылку на callpy
    this.setUtm = function()
    {
        //подстановка ссылки на Callpy с UTM-метками
        $jcallpy("#callpy_link, .callpy_link").attr('href', 'http://callpy.com/?utm_source='+m_callpy.client_data.site+'&utm_medium='+(m_callpy.client_data.peer_key?'online':'offline')+'&utm_term='+($jcallpy.callpy_status('api').visible?'chat':'shortcut')+'&utm_campaign=callpy');
        $jcallpy("#shortcut_callpy_link").attr('href', 'http://callpy.com/?utm_source='+m_callpy.client_data.site+'&utm_medium='+(m_callpy.client_data.peer_key?'online':'offline')+'&utm_term='+($jcallpy.callpy_status('api').visible?'chat':'shortcut')+'&utm_campaign=callpy');
    }

    //вызывается по нажатию кнопки "позвонить" или "принять вызов"
    this.call = function ()
    {
        var call_flag = localStorage.getItem("callpy_call_flag");
        //флаг в значении null - значит, нет ни дозвона, ни звонка, ни исходящего вызова (нажали "позвонить")
        if (!call_flag){

            if (m_callpy.m_storage.restoreInIE) m_callpy.m_storage.handleCallFlag = false;
            localStorage.setItem("callpy_call_flag",2);

            //флешка или webrtc
            if (m_callpy.m_flash.webRTCsupp == 1 && m_callpy.managers_list[m_callpy.client_data.peer_key].webRTCsupp == 1) {
                m_callpy.m_chat.call_webrtc();
            }else{
                //TODO: показать заглушку при загрузке флешки (GUI)
                /*
                var callpy_chat = {
                    place: $jcallpy('#callpy_main_container')
                };

                callpy_chat.l = callpy_chat.place.offset().left;
                callpy_chat.t = callpy_chat.place.offset().top;
                callpy_chat.w = callpy_chat.place.outerWidth();
                callpy_chat.h = callpy_chat.place.outerHeight();


                $jcallpy('<div/>', {
                    css: {
                        position: 'fixed',
                        left: callpy_chat.l,
                        top: callpy_chat.t,
                        width: callpy_chat.w,
                        height: callpy_chat.h,
                        zIndex: 99999,
                        background: 'rgba(0,0,0,0.3)',
                        borderRadius: '5px',
                        display: 'table'
                    },
                    id: 'callpy_access_to_equip_overlay_flash',
                    html: '<div id="callpy_access_to_equip_flash" style="display:table-cell;vertical-align:middle;text-align:center; color: #FFFFFF;font-size: 14px; font-weight: bold;">Загрузка...</div>'
                }).appendTo(document.body);
                */

                m_callpy.m_flash.start_flash();
            }

        }else if (call_flag == 1){
            //входящий звонок (нажали "ответить")

            //if (m_callpy.m_storage.restoreInIE) m_callpy.m_storage.handleCallFlag = false;
            //localStorage.setItem("callpy_call_flag",3);

            //флешка или webrtc
            if (m_callpy.m_flash.webRTCsupp == 1 && m_callpy.managers_list[m_callpy.client_data.peer_key].webRTCsupp == 1) {
                m_callpy.m_flash.start_webrtc(true, true);
            }else{
                //TODO: показать заглушку при загрузке флешки (GUI)
                /*
                var callpy_chat = {
                    place: $jcallpy('#callpy_main_container')
                };

                callpy_chat.l = callpy_chat.place.offset().left;
                callpy_chat.t = callpy_chat.place.offset().top;
                callpy_chat.w = callpy_chat.place.outerWidth();
                callpy_chat.h = callpy_chat.place.outerHeight();


                $jcallpy('<div/>', {
                    css: {
                        position: 'fixed',
                        left: callpy_chat.l,
                        top: callpy_chat.t,
                        width: callpy_chat.w,
                        height: callpy_chat.h,
                        zIndex: 99999,
                        background: 'rgba(0,0,0,0.3)',
                        borderRadius: '5px',
                        display: 'table'
                    },
                    id: 'callpy_access_to_equip_overlay_flash',
                    html: '<div id="callpy_access_to_equip_flash" style="display:table-cell;vertical-align:middle;text-align:center; color: #FFFFFF;font-size: 14px; font-weight: bold;">Загрузка...</div>'
                }).appendTo(document.body);
                */
                m_callpy.m_flash.start_flash();
            }

        }
    }

    //вызывается, когда нажимаем "отклонить" входящий вызов, "завершить" наш исходящий либо "завершить" состоявшийся звонок
    //noMedia - когда при дозвоне без разрешения доступа к оборудованию нажимаем "отменить"" (в этом случае нет необходимости посылать менеджеру сообщение об отмененном вызове)
    this.endCall = function(noMedia)
    {
        var call_flag = localStorage.getItem("callpy_call_flag");
        //входящий звонок (дозвон)
        if (call_flag==1){
            _this.end_dialup_from_self();
        }else if (call_flag==2){
            //исходящий звонок (дозвон)
            _this.end_dialup_from_self(noMedia);
        }else if (call_flag==3){
            //состоявшийся звонок завершаем
            m_callpy.m_chat.end_call_from_self();
        }
    };

    //завершение звонка для звонка через Webrtc
    //меняет статус звонка и удаляет созданные потоки
    this.end_call_webrtc = function() {

        _this.call_status = "no_call";
        //_this.first_time = true;
        _this.save_state = 0;

        if (document.getElementById("callpy_webrtc_video_tag")) document.getElementById("callpy_webrtc_video_tag").src = "";
        if (document.getElementById("callpy_webrtc_video_self_tag")) document.getElementById("callpy_webrtc_video_self_tag").src = "";
        if (m_callpy.m_flash.pc) m_callpy.m_flash.pc.close();
        if (m_callpy.m_flash.stream) {
            m_callpy.m_flash.stream.getTracks().forEach(function(e){e.stop()});
            //m_callpy.m_flash.stream.stop();
        }

        m_callpy.m_flash.pc = null;
        m_callpy.m_flash.stream = null;
        m_callpy.m_flash.remotestream = null;

    }

    //завершение звонка для звонка через Flash
    this.end_call = function ()
    {

            _this.call_status = "no_call";
            _this.first_time = true;
            _this.save_state = 0;

            return true;
    };

    //вызывается, когда собеседник завершает звонок
    this.end_call_from_peer = function ()
    {
        //обрабатываем ТОЛЬКО на вкладке со звонком (на остальных синхронизуется через LS)
        //здесь дополнительной проверки не нужно, т.к. выполнится ТОЛЬКО при уже состоявшемся звонке (status == "call")
        //TODO: NEW CHAT: изменить проверку
        //if ($jcallpy.callpy_call('status').status == "call"){
        if (m_callpy.m_chat.call_status == "call"){
            if (m_callpy.m_storage.restoreInIE) m_callpy.m_storage.handleCallFlag = false;
            localStorage.removeItem("callpy_call_flag");
            if (m_callpy.m_flash.call_type=="webrtc"){
                _this.end_call_webrtc();
                //$jcallpy.callpy_call('end');
            }
            else {
                m_callpy.m_flash.end_flash();
                //$jcallpy.callpy_call('end');
            }
            $jcallpy.callpy_status('set','call_off');
            m_callpy.m_flash.stop_ping();
            $jcallpy.callpy_call('_removeIframe');
        }else{
            $jcallpy.callpy_status('set','call_off');
        }
    }

    //вызывается, когда мы сами завершаем звонок
    this.end_call_from_self = function ()
    {
        m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("end_call"));
        if (m_callpy.m_storage.restoreInIE) m_callpy.m_storage.handleCallFlag = false;
        localStorage.removeItem("callpy_call_flag");
        //TODO: NEW CHAT: изменить проверку
        //if ($jcallpy.callpy_call('status').status == "call"){
        if (m_callpy.m_chat.call_status == "call"){
            if (m_callpy.m_flash.call_type=="webrtc"){
                _this.end_call_webrtc(); //GUI здесь не вызывается, т.к. именно функция GUI и вызывает текущую
                //TODO: потребуется вызов GUI
            }
            else{
                m_callpy.m_flash.end_flash();
            }
            m_callpy.m_flash.stop_ping();
            $jcallpy.callpy_call('_removeIframe');
        }else{
            //m_callpy.m_storage.restoreHtml();
        }

    }

    //собеседник отклоняет дозвон
    this.end_dialup_from_peer = function ()
    {
        m_callpy.m_autos.checkAllConditions({dialup_end: 'peer'});
        //обрабатываем ТОЛЬКО на вкладке со звонком (на остальных синхронизуется через LS)
        //TODO: NEW CHAT: изменить проверку
        //if ($jcallpy.callpy_call('status').status){
        if (m_callpy.m_chat.call_status!="no_call"){
            //FIXED: дополнительная проверка: если пришло сообщение об отмене дозвона, а на самом деле у клиента уже состояние звонка (такое возможно при очень плохой связи или обрывах)
            if (localStorage.getItem("callpy_call_flag")=="3"){
                _this.end_call_from_peer();
                return;
            }
            if (m_callpy.m_storage.restoreInIE) m_callpy.m_storage.handleCallFlag = false;
            localStorage.removeItem("callpy_call_flag");
            if (m_callpy.m_flash.call_type=="webrtc"){
                //TODO: NEW CHAT: изменить проверку
                //if ($jcallpy.callpy_call('status').status == 'incoming' || $jcallpy.callpy_call('status').status == 'access_equip') {
                if (m_callpy.m_chat.call_status == 'incoming') {
                    //if ($jcallpy.callpy_call('status').status == 'access_equip') $jcallpy("#callpy_access_to_equip_overlay").hide();
                    //$jcallpy.callpy_call('incoming_cancel');
                    $jcallpy.callpy_status('set', 'incoming_call_off');
                } else {
                    //$jcallpy.callpy_call('out_cancel');
                    $jcallpy.callpy_status('set', 'dial_off');
                }
                _this.end_call_webrtc();
            }
            else {
                //TODO: NEW CHAT: изменить проверку
                //if ($jcallpy.callpy_call('status').status == 'incoming' || $jcallpy.callpy_call('status').status == 'access_equip') {
                if (m_callpy.m_chat.call_status == 'incoming') {
                    //$jcallpy.callpy_call('incoming_cancel');
                    $jcallpy.callpy_status('set', 'incoming_call_off');
                } else {
                    //$jcallpy.callpy_call('out_cancel');
                    $jcallpy.callpy_status('set', 'dial_off');
                }
                m_callpy.m_flash.end_flash();
            }
            m_callpy.m_flash.stop_ping();
            clearTimeout(m_callpy.m_flash.dialupTimer);
        }

    }

    //отклоняем дозвон сами
    this.end_dialup_from_self = function (noMedia)
    {
        m_callpy.m_autos.checkAllConditions({dialup_end: 'self'});
        if (!noMedia) m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("end_dialup"));
        if (m_callpy.m_storage.restoreInIE) m_callpy.m_storage.handleCallFlag = false;
        localStorage.removeItem("callpy_call_flag");
        //debugger;
        //TODO: NEW CHAT: изменить проверку
        //if ($jcallpy.callpy_call('status').status){
        if (m_callpy.m_chat.call_status!="no_call"){
            //if ($jcallpy.callpy_call('status').status == 'incoming') {
            if (m_callpy.m_chat.call_status == 'incoming') {
                //TODO: сообщение в чат (вызов отклонен)
                //$jcallpy.callpy_call('incoming_cancel_self');
                //localStorage.removeItem("callpy_incoming_call");
            }//TODO: NEW CHAT: изменить проверку
            //else if ($jcallpy.callpy_call('status').status == 'outcoming' || $jcallpy.callpy_call('status').status == 'access_equip'){
            else if (m_callpy.m_chat.call_status == 'calling_to_manager'){
                //TODO: сообщение в чат "вы отменили звонок"
                //$jcallpy.callpy_call('out_cancel', 'Вы отменили звонок');
            }
            if (m_callpy.m_flash.call_type=="webrtc"){
                _this.end_call_webrtc(); //если звонил менеджер, то у клиента и не был создан поток. Но в функции есть проверка, ошибки не возникнет
            }
            else {
                m_callpy.m_flash.end_flash();
            }
        }
        else{
            //m_callpy.m_storage.restoreHtml();
        }

        m_callpy.m_flash.stop_ping();
        clearTimeout(m_callpy.m_flash.dialupTimer);
    }

    this.start_call = function (withVideo)
    {

        _this.call_status = "call";

        m_callpy.m_bridge.flash_object.to_flash("to_flash",{action: "start_call", withVideo: withVideo});
        //TODO: заменить на аналог
        $jcallpy.callpy_call('_createIframe');
        //записываем время начала звонка для синхронизации таймеров на всех вкладках
        localStorage.setItem("callpy_call_time", new Date().getTime());
        //m_callpy.m_gui_chat.iframe_call_function();  //TODO вклеить в функции Коляна
        return true;
    };

    //вызывается, когда от менеджера приходит сообщение, что он принял звонок, либо когда сами отвечаем положительно на звонок менеджера (после получения потока)
    this.answer = function (data)
    {
        if (m_callpy.m_flash.webRTCsupp == 1 && m_callpy.managers_list[m_callpy.client_data.peer_key].webRTCsupp == 1){

            if (m_callpy.m_flash.stream || data["noOffer"]){ //только если существует полученный поток (а он существует только на вкладке, где начинали звонок), т.е. обрабатываем только на вкладке со звонком, на других - ничего не делаем

                _this.call_status = "call";

                //m_callpy.m_gui_chat.iframe_call_function(); //создаем iframe у клиента
                $jcallpy.callpy_call('_createIframe');
                //записываем время начала звонка для синхронизации таймеров на всех вкладках
                localStorage.setItem("callpy_call_time", new Date().getTime());

                //m_callpy.m_gui_chat.create_webrtc_block(); //создаем блок для webrtc (и окно для видео, пока скрытое)
                if (!data["noOffer"]){ //data['noOffer'] передается (равно true) только когда клиент сам положительно отвечает на звонок менеджера. Флаг выставляется в получении потока
                    //m_callpy.m_flash.createOffer();
                    localStorage.setItem("callpy_call_flag", "3"); //в случае, когда менеджер отвечает на наш звонок, флаг до этого момента не выставляется; выставляем здесь
                } //peerConnection - начать звонок (только в случае, если менеджер принял звонок, иначе (мы приняли) - createOffer делает менеджер)

                if (!data['noOffer'])$jcallpy.callpy_status('set', 'call_on');
                else $jcallpy.callpy_status('set', 'call_on', true); //если передаётся noOffer, то значит действие вызвано кликом клиента; необходимо восстановить LS в других вкладках
                //$jcallpy.callpy_call('start'); //пишем в чат системное сообщение, что идет звонок + показываем кнопку переключения в видео-режим, если это возможно

            }else if (!m_callpy.m_flash.stream){
                _this.call_status = "no_call";
                $jcallpy.callpy_status('set', 'call_on');
            }

        }else{

            //FIX: обрабатываем ответ только на вкладке со звонком
            if (document.getElementById("callpy_access_to_equip_flash")){

                _this.call_status = "call";
                //TODO: заменить на аналог
                $jcallpy.callpy_call('_createIframe');
                //записываем время начала звонка для синхронизации таймеров на всех вкладках
                localStorage.setItem("callpy_call_time", new Date().getTime());

                //m_callpy.m_gui_chat.iframe_call_function();
                //if (data["noOffer"]){
                    m_callpy.m_bridge.flash_object.to_flash("to_flash",{action: "start_call", withVideo: false});
                //}
                localStorage.setItem("callpy_call_flag", "3");

                $jcallpy.callpy_status('set', 'call_on');
                //$jcallpy.callpy_call('start');
            }else{
                _this.call_status = "no_call";
                $jcallpy.callpy_status('set', 'call_on');
            }

        }

    };

    /*
    this.incoming = function (data)
    {
        if (data["video"]=="true")
        {
            m_callpy.m_gui_chat.on_video_call({'type' : "incoming"});
        }
        else
        {
            m_callpy.m_gui_chat.on_audio_call({'type' : "incoming"});

        }
    };
    */


    this.call_webrtc = function ()
    {
        _this.save_state = 1;
        _this.call_status = 'calling_to_manager';
        m_callpy.m_flash.start_webrtc(true, true);
    }

    this.message_sent = function(messageData, guiCallback)
    {
        return function(data) {
          if(!data) data = {}
            data = JSON.parse(data)??null;
            if (data["_id"] && data["_id"]["$id"]){
              messageData["_id"] = data["_id"];
            }
            messageData["time"] = data["timestamp"];
            messageData["status_sent"] = data["timestamp"];
            messageData["timestamp"] = data["timestamp"];
            if (data["extData"]) messageData["extData"] = data["extData"];

            _this.history.push(messageData);
            const addedHistory = _this.history
            data['action'] = 'send_message'
            watchMessageAndUpdateHistory({data, history:addedHistory})
            
            if (guiCallback) guiCallback(messageData);
            /*
                _this.history.push(
                    {"_id": data["_id"], "message" : message, "receiver" : m_callpy.client_data.key, "sender" : m_callpy.client_data.peer_key, "received": 0, read: 1});
            else
                _this.history.push(
                    {"message" : message, "receiver" : m_callpy.client_data.key, "sender" : m_callpy.client_data.peer_key, "received": 0, read: 1});
            */

            //UPDATED: проверка условий
            m_callpy.m_autos.checkAllConditions({message: messageData["message"]});
            m_callpy.m_autos.checkTimeoutCondition();



        }
    };

    this.message_sent_dialog = function(messageData, guiCallback)
    {
        return function(data){
            data = JSON.parse(data);
            if (data["_id"] && data["_id"]["$id"]){
                messageData["_id"] = data["_id"];
            }
            messageData["timestamp"] = data["timestamp"];
            if (data["extData"]) messageData["extData"] = data["extData"];
            if (!_this.history_dialogs[messageData["dialogId"]]) _this.history_dialogs[messageData["dialogId"]] = [];

            _this.history_dialogs[messageData["dialogId"]].push(messageData);
            if (guiCallback) guiCallback(messageData);

            
        }
    };

    this.send_message_click = function (messageOptions)
    {   console.log('messageOptions', messageOptions)
        const {message, callback:guiCallback, messageType, additionalData} = messageOptions

        _this.block_from_self = true;
        var send_message_proceed = function(ids){
            var sendData;
            //UPDATED: для GA
            if (window.gtag){
                window.gtag('event', 'send_message', {
                    'event_category': 'callpy'
                });
                if (_this.history.length>0 && _this.history[_this.history.length - 1]['recieved'] == 1 && !_this.history[_this.history.length - 1]['_id']){
                    window.gtag('event', 'answer_to_automessage', {
                        'event_category': 'callpy'
                    });
                }
            } else if (window.ga){
                //событие "написал сообщение"
                window.ga('send', 'event', 'callpy', 'send_message');
                //событие "ответил на автоприглашение" - если предыдущее сообщение - автоматическое
                if (_this.history.length>0 && _this.history[_this.history.length - 1]['recieved'] == 1 && !_this.history[_this.history.length - 1]['_id']){
                    window.ga('send', 'event', 'callpy', 'answer_to_automessage');
                }
            }
            //UPDATED: яндекс.метрика (в случае, если настроено)
            if (window.ym && m_callpy.client_data.site_info.integrations && m_callpy.client_data.site_info.integrations.ANALYTICS && m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA && m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA.counterId){
                window.ym(m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA.counterId, 'reachGoal', 'CALLPY_FIRST_MESSAGE');
            }else{
                //Для старой версии Я.Метрики
                if (m_callpy.client_data.site_info.integrations && m_callpy.client_data.site_info.integrations.ANALYTICS && m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA && m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA.counterId){
                    if (window["yaCounter" + m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA.counterId]){
                        window["yaCounter" + m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA.counterId].reachGoal('CALLPY_FIRST_MESSAGE');
                    }
                }
            }

            sendData = {
                "message": message,
                "managerName": m_callpy?.managers_list[m_callpy.client_data.peer_key]?.name??'--'
            };
            //UPDATED: если последнее сообщение - автоматическое, и с момента его появления прошло менее 2 мин, передаём данные серверу
            //UPDATED: в случае, если это начало диалога, будем считать, что диалог инициирован автоматическим сообщением (для статистики)
            if (_this.history.length>0 && _this.history[_this.history.length - 1]['received'] == 1 && !_this.history[_this.history.length - 1]['_id'] && (new Date().getTime()/1000 - _this.history[_this.history.length - 1]['time']) < 120 && !m_callpy.client_data.autoClosed){
                sendData["to_auto"] = 1;
            }
            if (messageType){
                sendData["messageType"] = messageType;
                switch (messageType){
                    case 8:
                        sendData["messagesIds"] = JSON.stringify(additionalData["messagesIds"]);
                        if (additionalData["attached_site_id"]) sendData["attached_site_id"] = parseInt(additionalData["attached_site_id"]);
                        if (additionalData["attached_dialog_id"]) sendData["attached_dialog_id"] = parseInt(additionalData["attached_dialog_id"]);
                        if (additionalData["messagesIds_text"]) sendData["messagesIds_text"] = JSON.stringify(additionalData["messagesIds_text"]);
                        if (additionalData["jsTime"]) sendData["jsTime"] = JSON.stringify(additionalData["jsTime"]);
                        break;
                    default:
                        break;
                }
            }

            if (ids){
                sendData["ids"] = JSON.stringify(ids);
            }

            if (m_callpy.m_bridge.to_peer(
                    m_callpy.m_message.create_message("send_message", sendData), _this.message_sent({
                        departmentId: m_callpy.client_data.department_id,
                        extData: [],
                        managerId: m_callpy.client_data.peer_key,
                        managerName: m_callpy?.managers_list[m_callpy.client_data.peer_key]?.name??'--',
                        message: message,
                        receiver: m_callpy.client_data.peer_key,
                        recieved: 0,
                        sender: m_callpy.client_data.key,
                        status_read: 0,
                        status_received: 0,
                        status_sent: 0, //заполняется временем сервера при обработке колбэка
                        time: 0, //заполняется временем сервера при обработке колбэка
                        timestamp: 0, //заполняется временем сервера при обработке колбэка
                        type: (messageType ? messageType : 0) //тип сообщения
                    }, guiCallback)))
            {
                //UPDATED: соотв. событие
                if (!m_callpy.client_data.sendMessageEvent){
                    m_callpy.client_data.sendMessageEvent = true; //действует только в рамках сессии. В следующей сессии опять будет сгенерировано (макс. 1 раз за сессию)
                    callpy_api.events._fireCallback('sendMessage');
                }

                if (!localStorage["callpy_historyFlag"]) {
                    localStorage["callpy_historyFlag"] = true;
                    m_callpy.m_logger.log("Вызов update_status при send_message");
                   // m_callpy.m_bridge.to_fms({action: "update_status", status: "1" + (($jcallpy.callpy_status('api').visible&&m_callpy.client_data.peer_key)?"1":"0") + "1", peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0), domain: m_callpy.client_data.site, referer: encodeURIComponent(window.location.href), width: $jcallpy(window).width(), title: document.title});
                }
                //m_callpy.m_activity.add_activity(1099, true); //не посылаем сообщение об изменении уровня активности - обработаем в get_message у менеджера
                /*
                 _this.history.push(
                 {"message" : message, "receiver" : m_callpy.client_data.key, "sender" : m_callpy.client_data.peer_key, "received": 0, read: 1});
                 */
                var greets = localStorage.getItem("callpy_greets");
                if (greets) greets = JSON.parse(greets);
                else {
                    localStorage.setItem("callpy_greets_timer", new Date().getTime());
                    greets = {};
                }
                //при отправке сообщения необходимо отключить все автоприветствия
                for (var i=0; i<m_callpy.client_data.site_info.greets.length; i++){
                    if (!greets[m_callpy.client_data.site_info.greets[i].id]) greets[m_callpy.client_data.site_info.greets[i].id] = 1;
                }
                localStorage.setItem("callpy_greets", JSON.stringify(greets));
                //а также запустить таймеры удерживающих сообщений, в случае, если это первое сообщение в текущей сессии
                if (!localStorage.getItem("callpy_hm")){
                    localStorage.setItem("callpy_hm", new Date().getTime());
                    m_callpy.m_activity.holding_init();
                }

                //UPDATED: таймер формы оценки диалога
                if (_this.dialogRateTimer) clearTimeout(_this.dialogRateTimer);
                if (m_callpy.client_data.site_id != 19283) _this.dialogRateTimer = setTimeout(function(){
                    //TODO: возможно, вызывать не окончание диалога?
                    _this.dialogClosed();
                }, 5*60*1000);

                return true;
            }
            else
            {
                return false;
            }
        };

        //UPDATED: флаг для записи системных сообщений
        if (!m_callpy.client_data.saveSysMes){
            m_callpy.client_data.saveSysMes = 1;
            m_callpy.m_storage.saveData();
            //TODO: проверить, есть ли на данный момент автоматические сообщения, которые необходимо записать в БД
            var messages = [], curTime = new Date().getTime() / 1000;
            for (var i = m_callpy.m_chat.history.length - 1; i >=0; i--){
                //проверяем только сообщения, полученные или отправленные после входа клиента на сайт (текущяя сессия)
                if (m_callpy.m_chat.history[i].timestamp && m_callpy.m_chat.history[i].timestamp < m_callpy.client_data.timestamp) break;
                //UPDATED: к автоматическим сообщениям добавим запись системных сообщений
                if ((m_callpy.m_chat.history[i].type == 6 || m_callpy.m_chat.history[i].type == 4) && !m_callpy.m_chat.history[i]["_id"]){
                    //автоматическое сообщение, у которого отсутствует _id
                    messages.push({type: m_callpy.m_chat.history[i].type, message: m_callpy.m_chat.history[i].message, seconds: curTime - m_callpy.m_chat.history[i].timestamp, iterator: i});
                }
            }
            if (messages.length > 0){
                $jcallpy.post(callpy_global.php_server + '/d/', {
                    action: "save_sys_messages",
                    site_id: m_callpy.client_data.site_id,
                    site_url: m_callpy.client_data.site,
                    site: m_callpy.client_data.site,
                    managerName: m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                    key: m_callpy.client_data.key,
                    peer_key: m_callpy.client_data.peer_key,
                    channel: m_callpy.client_data.channel,
                    messages: JSON.stringify(messages)
                }, function(data) {
                    var ids = [];
                    data = JSON.parse(data);
                    //обработка, выставляем _id и серверное время в массиве сообщений
                    if (data.length == messages.length){
                        for (var i=0; i<data.length; i++){
                            m_callpy.m_chat.history[messages[i]["iterator"]].time = data[i]["time"];
                            m_callpy.m_chat.history[messages[i]["iterator"]].timestamp = data[i]["timestamp"];
                            m_callpy.m_chat.history[messages[i]["iterator"]]["_id"] = data[i]["_id"];
                            ids.push(data[i]["_id"]["$id"]);
                        }
                    }
                    send_message_proceed(ids); //передаём идентификаторы автоматических сообщений, которым необходимо проставить id диалога
                });
            }else{
                send_message_proceed();
            }
        }else{
            send_message_proceed();
        }

    };

    /**
     * Метод посылает сообщения в диалог. Один из диалогов должен быть ВЫБРАН (см. соотв. метод)
     * Выбранный диалог сохраняется в m_callpy.client_data
     * @param message
     * @param guiCallback
     * @returns {boolean}
     */

    this.send_message_click_dialog = function (message, guiCallback, messageType, additionalData)
    {
        var sendData;
        if (!m_callpy.client_data.dialog_id) return false;
        //UPDATED: для GA
        if (window.gtag){
            window.gtag('event', 'send_message', {
                'event_category': 'callpy'
            });
        } else if (window.ga){
            //событие "написал сообщение"
            window.ga('send', 'event', 'callpy', 'send_message');
        }

        //UPDATED: яндекс.метрика (в случае, если настроено)
        if (window.ym && m_callpy.client_data.site_info.integrations && m_callpy.client_data.site_info.integrations.ANALYTICS && m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA && m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA.counterId){
            window.ym(m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA.counterId, 'reachGoal', 'CALLPY_FIRST_MESSAGE');
        }else{
            //Для старой версии Я.Метрики
            if (m_callpy.client_data.site_info.integrations && m_callpy.client_data.site_info.integrations.ANALYTICS && m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA && m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA.counterId){
                if (window["yaCounter" + m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA.counterId]){
                    window["yaCounter" + m_callpy.client_data.site_info.integrations.ANALYTICS.METRIKA.counterId].reachGoal('CALLPY_FIRST_MESSAGE');
                }
            }
        }

        sendData = {
            "domain": m_callpy.client_data.site, //для получения сущности Realplexor (фактически не нужно)
            "text": message,
            "dialog_id": m_callpy.client_data.dialog_id,
            "part_id": m_callpy.client_data.key,
            "part_site_id": m_callpy.client_data.site_id,
            "clientType": "client",
            "messageType": 0,
            "name": (m_callpy.client_data.clientInfo && m_callpy.client_data.clientInfo.formData && m_callpy.client_data.clientInfo.formData.contactForm)?m_callpy.client_data.clientInfo.formData.contactForm.name:""
        };
        if (messageType){
            sendData["messageType"] = messageType;
            switch (messageType){
                case 8:
                    sendData["messagesIds"] = JSON.stringify(additionalData["messagesIds"]);
                    if (additionalData["attached_site_id"]) sendData["attached_site_id"] = parseInt(additionalData["attached_site_id"]);
                    if (additionalData["attached_dialog_id"]) sendData["attached_dialog_id"] = parseInt(additionalData["attached_dialog_id"]);
                    break;
                default:
                    break;
            }
        }

        if (m_callpy.m_bridge.to_fms(
                m_callpy.m_message.create_message("send_message_dialog", sendData), _this.message_sent_dialog({
                    "text": message,
                    "dialogId": m_callpy.client_data.dialog_id,
                    "partId": m_callpy.client_data.key,
                    "partSiteId": m_callpy.client_data.site_id,
                    "type": "client",
                    "messageType": (messageType ? messageType : 0),
                    "extData": {},
                    "name": (m_callpy.client_data.clientInfo && m_callpy.client_data.clientInfo.formData && m_callpy.client_data.clientInfo.formData.contactForm)?m_callpy.client_data.clientInfo.formData.contactForm.name:""
                }, guiCallback)))
        {
            //UPDATED: соотв. событие
            if (!m_callpy.client_data.sendMessageEvent){
                m_callpy.client_data.sendMessageEvent = true; //действует только в рамках сессии. В следующей сессии опять будет сгенерировано (макс. 1 раз за сессию)
                callpy_api.events._fireCallback('sendMessage');
            }

            if (!localStorage["callpy_historyFlag"]) {
                localStorage["callpy_historyFlag"] = true;
                m_callpy.m_logger.log("Вызов update_status при send_message");
                m_callpy.m_bridge.to_fms({action: "update_status", status: "1" + (($jcallpy.callpy_status('api').visible&&m_callpy.client_data.peer_key)?"1":"0") + "1", peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0), domain: m_callpy.client_data.site, referer: encodeURIComponent(window.location.href), width: $jcallpy(window).width(), title: document.title});
            }

            return true;
        }
        else
        {
            return false;
        }
    };

    this.get_message = function (data)
    {
        if (!localStorage["callpy_historyFlag"]) {
          localStorage["callpy_historyFlag"] = true;
          m_callpy.m_logger.log("Вызов update_status при get_message");
          m_callpy.m_bridge.to_fms({action: "update_status", status: "2" + (($jcallpy.callpy_status('api').visible&&m_callpy.client_data.peer_key)?"1":"0") + "1", peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0), domain: m_callpy.client_data.site});
        }

        if (!data["mtype"]) data["message"] = m_callpy.urlHighlight(data["message"]);
        /*$jcallpy.callpy_chat('message', {
            text: data.message,
            from: 1
        });*/

        var messageData = {
            "message" : data["message"],
            "receiver" : data["peer_key"],
            "sender" : data["key"],
            "managerName": data["managerName"],
            "received": 1,
            "status_sent": data["serverTime"],
            "status_received": data["serverTime"],
            "status_read": 0,
            "time": data["serverTime"],
            "timestamp": data["serverTime"],
            "type": (!data["mtype"]?0:(data["mtype"]!='image'?(data["mtype"]!='formFill'?3:7):2)),
            "extData": data["extData"],
            "_id": data["_id"]
        };
        //console.log('get_message_self------------->', data)
        if (data["messageType"]) messageData["type"] = data["messageType"];
        //====> Ajout virsuel dans la liste des messages
        // $jcallpy.callpy_message('add', {
        //     text: data.message,
        //     from: 1,
        //     time: new Date().getTime(),
        //     read: 0,
        //     originalData: messageData,
        //     messageType: messageData["type"]
        // });

        _this.contactFormII(data["message"]);
      
        _this.history.push(messageData);
        // const mCallpy = window?.m_callpy??null
        // if(mCallpy?.initialize_data?.history) {
        //   const initHistory = mCallpy.initialize_data.history
        //   const addedHistory = _this.history
        //   const newListHistory = [...initHistory, ...addedHistory]
        //   //console.log('newListHistory', newListHistory)
        //   windowDispachStorage({data, key:'new_history', keyData:newListHistory})
        // }
        const addedHistory = _this.history
        watchMessageAndUpdateHistory({data, history:addedHistory})
        
        
        
        

        //UPDATED: отправим данные о том, что сообщение получено
        if (data["_id"] && data["_id"]["$id"]) m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("message_received", {"messageId": data["_id"]["$id"]}));

        //остановим таймеры автоприветствий
        var greets = localStorage.getItem("callpy_greets");
        if (greets) greets = JSON.parse(greets);
        else {
            localStorage.setItem("callpy_greets_timer", new Date().getTime());
            greets = {};
        }
        //при получении сообщения необходимо отключить все автоприветствия
        for (var i=0; i<m_callpy.client_data.site_info.greets.length; i++){
            if (!greets[m_callpy.client_data.site_info.greets[i].id]) greets[m_callpy.client_data.site_info.greets[i].id] = 1;
        }
        localStorage.setItem("callpy_greets", JSON.stringify(greets));

        if (m_callpy.m_activity.holdingTimer){
            for (var key in m_callpy.m_activity.holdingTimer){
                clearTimeout(m_callpy.m_activity.holdingTimer[key]);
            }
            m_callpy.m_activity.holdingTimer = null;
            //FIXED: при переходе по странице таймеры возобновятся. Необходимо отключить вообще удерживающие на эту сессию
            var holds = {};
            for (var i=0; i<m_callpy.client_data.site_info.holds.length; i++){
                holds[m_callpy.client_data.site_info.holds[i].id] = 1;
            }
            localStorage["callpy_holds"] = JSON.stringify(holds);
        }
        //в случае, если вкладка активна и чат развернут, сразу же отмечаем как прочитанное
        _this.setMessagesRead();

        //UPDATED: таймер формы оценки диалога
        if (_this.dialogRateTimer) clearTimeout(_this.dialogRateTimer);
        if (m_callpy.client_data.site_id != 19283) _this.dialogRateTimer = setTimeout(function(){
            //TODO: возможно, вызывать не окончание диалога?
            _this.dialogClosed();
        }, 5*60*1000);

        //UPDATED: проверка условий (могло выполниться условие об активном диалоге)
        m_callpy.m_autos.checkAllConditions();
    };

    this.get_message_self = function (data)
    {

        if (data["from_call_window"]){
            var message = $jcallpy.callpy_message('add', {
                text: data["message"],
                from: 0,
                time: new Date().getTime(),
                self: true
            });
        }


    };

    this.get_message_dialog = function (data)
    {
        if (parseInt(data['part_id']) === parseInt(m_callpy.client_data.key) && parseInt(data['part_site_id']) === parseInt(m_callpy.client_data.site_id)) {
            return;
        }

        if (!localStorage["callpy_historyFlag"]) {
            localStorage["callpy_historyFlag"] = true;
            m_callpy.m_logger.log("Вызов update_status при get_message");
            m_callpy.m_bridge.to_fms({action: "update_status", status: "2" + (($jcallpy.callpy_status('api').visible&&m_callpy.client_data.peer_key)?"1":"0") + "1", peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0), domain: m_callpy.client_data.site});
        }

        if (!data["mtype"]) data["message"] = m_callpy.urlHighlight(data["message"]);
        var messageData = {
            _id: data["id"],
            dialogId: data["dialog_id"],
            partId: data["part_id"],
            partSiteId: data["part_site_id"],
            type: data["clientType"],
            text: data["message"],
            name: data["name"],
            messageType: data["messageType"],
            timestamp: data["timestamp"],
            extData: data["extData"]
        };

        //необходимо проверить, выбран ли в данный момент этот диалог
        if (m_callpy.client_data.dialog_id && m_callpy.client_data.dialog_id == data["dialog_id"]){
            //диалог выбран

            callpy_gui.dialogs.global.dialog_messages.push($jcallpy.callpy_message('add', {
                text: data["message"],
                from: 1,
                name: data['name'],
                messageType: 'dialogs',
                time: data["timestamp"],
                id: data["id"],
                dialogId: data["dialog_id"],
                originalData: messageData
            }));

        }
        else {
            console.log("GUI пришло сообщение в диалог, а он не выделен!");
            //активна либо основная переписка, либо другой диалог
            m_callpy.client_data.dialogs[data["dialog_id"]]["unread"]++;
            //GUI
            callpy_gui.dialogs.global.dialogs_list[data["dialog_id"]].options.unread++;
            callpy_gui.dialogs.global.dialogs_list[data["dialog_id"]]._setUnreadCount();

            //TODO: GUI: нотификация о том, что есть непрочитанные сообщения в диалоге
            //TODO: необходимо где-то хранить информацию о количестве непрочитанных сообщений (она будет получена при инициализации диалога?)
            //TODO: для получения информации необходимо сделать выборку из сообщений диалога. Следовательно, необходимо
            //TODO: сохранять где-то информацию в Redis отдельно, только количество непрочитанных (или сам факт их наличия)
        }
        //UPDATED: обновление последнего сообщения диалога
        m_callpy.client_data.dialogs[data["dialog_id"]]["last_message"] = data["message"];

        _this.contactFormII(data["message"]);

        if (_this.history_dialogs[data["dialog_id"]]){
            _this.history_dialogs[data["dialog_id"]].push(messageData);
        }

        //_this.history.push({"message" : data["message"], "receiver" : data["peer_key"], "sender" : data["key"], "received": 1, "status_sent": data["serverTime"], "status_received": data["serverTime"], "status_read": 0, "type": (!data["mtype"]?0:(data["mtype"]!='image'?3:2)), "_id": data["_id"]});


    };

    this.message_received = function (data)
    {

    };

    this.set_messages_read = function (data)
    {

    };

    this.edit_message = function(data)
    {

        if (!data["mtype"]) data["message"] = m_callpy.urlHighlight(data["message"]);
        for (var i=_this.history.length-1; i>=0; i--){
            if (_this.history[i]["id"] && _this.history[i]["id"]["$id"] == data["messageId"]){
                _this.history[i]["message"] = data["message"];
                m_callpy.m_storage.saveData();
                break;
            }
        }
        //TODO GUI: изменить визуально сообщение

        //console.log('edit_message', 'cuser_chat.js', 'TODO GUI: изменить визуально сообщение');

        $jcallpy.callpy_message('editMessage', {
            id: data["messageId"],
            message: data["message"]
        });
    };

    this.set_message_history = function (data)
    {
        _this.history = data["history"];
        //for (var i in _this.history)
        var unreadExists = false;
        for (var i=0; i<_this.history.length; i++)
        {
            //UPDATED: новая настройка для разделения истории по отделам. В случае, если данная настройка включена, визуально
            //выводятся только сообщения, которые касаются текущего отдела
            //Вообще говоря, в сообщении не хранится данных, к какому отделу оно относится
            //Здесь проверяется лишь консультант, к которому относится сообщение. И если в данный момент консультант
            //консультирует текущий отдел, сообщение оставляем. Иначе пропускаем
            //TODO: переписать - сейчас в сообщении есть id отдела, к которому сообщение относилось
            if (m_callpy.client_data.site_info["s_dividedDepsChats"] == 1){
                var messageFromThisDep = false;
                if (_this.history[i]["departmentId"]){
                    if (_this.history[i]["departmentId"] == m_callpy.client_data.department_id) {
                        messageFromThisDep = true;
                    }
                }else{
                    var managerId = (_this.history[i]["recieved"] == 0 ? _this.history[i]["receiver"] : _this.history[i]["sender"]);
                    if (m_callpy.managers_list[managerId]){
                        for (var j=0; j<m_callpy.managers_list[managerId].departments.length; j++){
                            if (m_callpy.managers_list[managerId].departments[j] == m_callpy.client_data.department_id){
                                messageFromThisDep = true;
                                break;
                            }
                        }
                    }

                }
                if (!messageFromThisDep) continue;
            }

            var mass = true;
            if (i == _this.history.length - 1)
            {
                mass = false;
            }

            /*$jcallpy.callpy_chat('message', {
                text: _this.history[i]["message"],
                from: (_this.history[i]["sender"] == m_callpy.client_data.key ? 0 : 1),
                animate: 0,
                mass: true
            });*/
            if (!_this.history[i]["status_read"]) unreadExists = true;
            //====> Presentation visuel
            // $jcallpy.callpy_message('add', {
            //     text: _this.history[i]["message"],
            //     from: (_this.history[i]["sender"] == m_callpy.client_data.key ? 0 : 1),
            //     animate: 0,
            //     mass: true,
            //     read: (!_this.history[i]["status_read"]?0:1),
            //     name: _this.history[i]["managerName"],
            //     time: _this.history[i]['time']*1000, //TODO: смещение относительно московского времени сервера (везде используется локальное время компьютера)
            //     originalData: _this.history[i],
            //     messageType: _this.history[i]['type']?_this.history[i]['type']:0,
            //     extData: _this.history[i]["extData"]?_this.history[i]["extData"]:null //UPDATED: доп. данные о типе сообщения "заполнил форму"
            // });
        }

        //в случае, если вкладка активна, и есть непрочитанные сообщения, считаем, что их прочли
        if (unreadExists) {
            //UPDATED: для GA
            if (window.gtag){
                window.gtag('event', 'read_offline_messages', {
                    'event_category': 'callpy'
                });
            } else if (window.ga){
                //событие "заполнение форм (контактов/etc)"
                window.ga('send', 'event', 'callpy', 'read_offline_messages');
            }
            _this.setMessagesRead();
        }

    };

    this.setMessagesRead = function()
    {
        if (m_callpy.m_storage.activeTab && $jcallpy.callpy_status('api')?.visible && !_this.setReadTimer){
            _this.setReadTimer = true;
            var exists = false;
            for (var i=_this.history.length-1; i>=0; i--)
            {
                //UPDATED: наши сообщения не интересуют
                if (_this.history[i].recieved==0) continue;
                //если статусы сообщения "по нулям" - это означает, что это старое сообщение, дальше нет смысла смотреть, остальные сообщения тоже без статусов, ещё более старые
                if (_this.history[i].recieved==1 && _this.history[i]["status_sent"] == 0 && _this.history[i]["status_received"] == 0 ) break;
                //UPDATED: если дошли до сообщения с ненулевым временем прочтения, то сброс (дальше все сообщения считаем прочтенными)
                if (_this.history[i].recieved==1 && _this.history[i]["status_read"] != 0) break;

                //Для клиента не важно, конкретное время прочтения сообщений консультанта - важно выставить флаг, что они прочтены
                //Здесь выставляется время по JS, на самом деле в базе эти сообщения хранятся с серверным timestamp
                //Главное, что время прочтения не нулевое, следовательно, повторно запрос не будет отсылаться
                _this.history[i]["status_read"] = Math.floor(new Date().getTime() / 1000);
                exists = true;
            }
            _this.setReadTimer = false;
            if (exists){

                m_callpy.m_bridge.to_fms({
                    action: 'setMessagesRead',
                    site_id: m_callpy.client_data.site_id,
                    site: m_callpy.client_data.site,
                    domain: m_callpy.client_data.site,
                    channel: m_callpy.client_data.channel,
                    key: m_callpy.client_data.key,
                    peer_key: m_callpy.client_data.peer_key,
                    peer_type: m_callpy.client_data.peer_type
                });

            }
        }

    };

    this.site_settings_changed = function (data){
        m_callpy.client_data.site_info[data['name']] = data['value'];
        if (data["name"]=="status" && data['value']=="1"){ //если сайт включился, то с этим сообщением пришел новый список менеджеров (которых, возможно, не было)
            for (var i=0; i<data["managers"].length; i++){
                if (!m_callpy.managers_list[data["managers"][i].key])m_callpy.register_client(data["managers"][i]);
            }
        }
        //если сменился тип чата, обновим переменную, подставляемую в строку запроса к скриптам, чтобы они взялись не из кеша
        if (data["name"]=="chat_type" || data["name"]=="label_type"){
            localStorage.setItem("callpy_lastchat", new Date().getTime());
            localStorage.removeItem("callpy_css"); //удаляем CSS, чтобы при перезагрузке страницы стили подгрузились новые
        }
        m_callpy.m_storage.saveData();
        //if (data["name"]!="status"){
            //$jcallpy.callpy_service('settings', {type: data['name'], value: data['value']});
            var setting = {};
            setting[data['name']] = data['value'];
           // $jcallpy.callpy_settings('set', setting);
        //}
    };

    this.get_user_avatar = function (id){
        if (m_callpy.managers_list[id]){
            return {normal: m_callpy.managers_list[id].avatar+".jpg", tail: m_callpy.managers_list[id].avatar+"_tail.png"};
            //if (m_callpy.managers_list[id].avatar==0) return {normal: id+".jpg", tail: id+"_tail.png"};
            //else return {normal: id+"_"+m_callpy.client_data.site+".jpg", tail: id+"_"+m_callpy.client_data.site+"_tail.png"};
        }
    };

    this.managerWriting = function(){
        //отрисовка состояния "консультант набирает текст"

        $jcallpy.callpy_message('add', {
            type: 'typing',
            from: 1,
            time: new Date().getTime(),
            read: 0,
            messageType: 5
        });

        clearTimeout(_this.managerWriteTimer);
        _this.managerWriteTimer = setTimeout(function () {
            //удаляем состояние "консультант набирает текст"
            $jcallpy.callpy_message('clearTyping');
        }, 5000);
    };

    this.contactFormII = function(message){
        var pattern = new RegExp('(оста|напиши|укажи|дай|как|ваш)[^\s]*([^\s]*\s){0,3}(телеф|ema|emial|mai|почт|зову|обраща|данн|номер)','i');
        if (pattern.test(message) && !m_callpy.client_data.contactFormIIShow){
            m_callpy.client_data.contactFormIIShow = 1;
            $jcallpy.callpy_forms('_userData_show');
            $jcallpy.callpy_forms('_button_inactive');
        }
    };

    this.getRateFormData = function(){

        if (m_callpy.client_data.site_info.likeFormId != 0 && m_callpy.client_data.site_info.forms[m_callpy.client_data.site_info.likeFormId] && m_callpy.client_data.site_info.forms[m_callpy.client_data.site_info.likeFormId].fields && m_callpy.client_data.site_info.forms[m_callpy.client_data.site_info.likeFormId].fields.length > 0){

            //Набор полей из базы
            var fields = [];
            for (var i=0; i<m_callpy.client_data.site_info.forms[m_callpy.client_data.site_info.likeFormId].fields.length; i++){
                fields.push({
                    field_id: m_callpy.client_data.site_info.forms[m_callpy.client_data.site_info.likeFormId].fields[i].id,
                    text: m_callpy.client_data.site_info.forms[m_callpy.client_data.site_info.likeFormId].fields[i].name
                });
            }
            return {
                'formtext': (m_callpy.client_data.site_info.forms[m_callpy.client_data.site_info.likeFormId].additional_data != '' ? m_callpy.client_data.site_info.forms[m_callpy.client_data.site_info.likeFormId].additional_data : _("Пожалуйста, оцените диалог")),
                'fields': fields
            };

        }else{
            //Стандартный набор полей
            return {
                'formtext': _("Ваше мнение очень важно для нас! Пожалуйста оцените диалог с консультантом:"),
                'fields': [
                    {field_id: 0, text: _("Не отвечает")},
                    {field_id: 0, text: _("Некомпетентеность")},
                    {field_id: 0, text: _("Хамство")}
                ]};
        }

    };

    this.dialogClosed = function (){

        callpy_gui.rate('showForm');
        callpy_gui.rates({action: "showForm", type: "binary"});
        //m_callpy.m_autos.checkAllConditions({closing_dialog: true});

    };

    this.add_to_dialog = function (data){

        if (!m_callpy.client_data.dialogs) m_callpy.client_data.dialogs = {};
        m_callpy.client_data.dialogs[data["dialog"]["id"]] = data["dialog"];
        m_callpy.client_data.dialogs[data["dialog"]["id"]]["unread"] = 0;

        m_callpy.realplexor.setCursor("dialog_" + data["dialog"]["id"] + "_" + data["dialog"]["channel"], data["dialog"]["join_time"]+0.1);
        m_callpy.realplexor.subscribe("dialog_" + data["dialog"]["id"] + "_" + data["dialog"]["channel"],
            function(data, id, cursor) {
                data = JSON.parse(data);
                //получим id диалога из id канала:
                var tmp = id.split("_");
                tmp = tmp[1];
                data["dialog_id"] = tmp;
                localStorage.setItem("callpy_cid", cursor);
                localStorage.setItem("callpy_lastRpx", new Date().getTime());
                m_callpy.m_bridge.from_flash(data);
            });


        m_callpy.realplexor.execute();

        //TODO GUI: нотификация о том, что добавили в диалог, вывод нового диалога в списке диалогов
        callpy_gui.dialogs('_addNewDialog', data["dialog"]);

    };

    //Новое сообщение в одном из диалогов
    this.dialog_message = function (data){
        console.log(data);
    };

    this.dialog_new_participant = function (data){
        var arr = m_callpy.client_data.dialogs_participants[data["dialog_id"]];

        if (arr){
            var user = {
                id: data["pid"],
                dialog_id: data["dialog_id"],
                part_id: data["part_id"],
                type: data["type"],
                part_site_id: data["part_site_id"],
                join_time: data["join_time"],
                remove_time: data["remove_time"],
                last_read_time: data["last_read_time"],
                status: data["status"],
                clientInfo: data["clientInfo"] ? data["clientInfo"] : null
            };

            let exists = false;
            /*
            m_callpy.client_data.dialogs_participants[data["dialog_id"]] = arr.map(item => {
                if (item["part_id"] === user["part_id"] && ["part_site_id"] === user["part_site_id"]) {
                    exists = true;
                    return user;
                }
                else {
                    return item;
                }
            });
            */
            m_callpy.client_data.dialogs_participants[data["dialog_id"]] = arr.map(function(item){
                if (item && item["part_id"] === user["part_id"] && item["part_site_id"] === user["part_site_id"]) {
                    exists = true;
                    return user;
                }
                else {
                    return item;
                }
            });

            if (!exists) m_callpy.client_data.dialogs_participants[data["dialog_id"]].push(user);
        }
        //TODO: GUI: системное сообщение о добавлении участника в диалог
        if (m_callpy.client_data.dialog_id == data["dialog_id"]){
            //в данный момент выбран этот диалог
            //TODO: GUI: отрисовать нового участника в списке
        }

    };

    this.dialog_remove_participant = function (data){

        if (m_callpy.client_data.dialogs_participants[data["dialog_id"]]){
            for (var i = 0; i < m_callpy.client_data.dialogs_participants[data["dialog_id"]].length; i++){
                if (m_callpy.client_data.dialogs_participants[data["dialog_id"]][i]["part_id"] == data["part_id"] && m_callpy.client_data.dialogs_participants[data["dialog_id"]][i]["part_site_id"] == data["site_id"] && m_callpy.client_data.dialogs_participants[data["dialog_id"]][i]["part_type"] == data["type"]){
                    m_callpy.client_data.dialogs_participants[data["dialog_id"]][i]["status"] = 0;
                    m_callpy.client_data.dialogs_participants[data["dialog_id"]][i]["remove_time"] = data["time"];
                    break;
                }
            }
        }

        if (data["part_id"] == m_callpy.client_data.key && data["site_id"] == m_callpy.client_data.site_id){
            //удалили самого клиента
            //TODO: GUI уведомление?
            m_callpy.realplexor.unsubscribe("dialog_" + m_callpy.client_data.dialogs[data["dialog_id"]]["id"] + "_" + m_callpy.client_data.dialogs[data["dialog_id"]]["channel"], null);
            m_callpy.realplexor.execute();
        }

        //TODO: GUI: системное сообщение о добавлении участника в диалог

        if (m_callpy.client_data.dialog_id == data["dialog_id"]){
            //в данный момент выбран этот диалог
            //TODO: GUI: удалить участника из списка, либо пометить неактивным
        }

    };

    this.screen_share = function(data)
    {
        if (data["status"]){
            switch (data["status"]) {
                //консультант запрашивает показ своего экрана
                case "request":
                    $jcallpy.callpy_status('set', 'screen_share_on');
                    break;
                //консультант запрашивает показ экрана клиента
                case "request_self":
                    $jcallpy.callpy_status('set', 'screen_self_share_on', true);
                    break;

            }
        }
    }

};
